module.exports = __webpack_public_path__ + "img/english4.dfb59d31.png";